import React, { useState, useEffect } from 'react';

//import { useParams } from 'react-router-dom';

import ExpertAcceptedConsultations from '../../components/Consultation/ExpertAcceptedConsultations'

import MainBlockHeader from '../MainBlockHeader'
import MainBlockContainer from '../MainBlockContainer';
import { useTranslation } from 'react-i18next';

export default function AcceptedConsultations() {  
  //let { userUid } = useParams();
  const { t } = useTranslation();

  return (
    <>              
      <MainBlockHeader header={t('consultation.expert.acceptedList.header')} >
      </MainBlockHeader>

      <MainBlockContainer>      
        <ExpertAcceptedConsultations />
      </MainBlockContainer>
    </>
  );  
}

